import { useState } from 'react';
import dayjs from 'dayjs';
import { getSolicitudCoberturaTramitesPorDelegacion } from '../../../../../../services/Busquedas/SolicitudCobertura';

export const useSolicitudCoberturaTramitesPorDelegacionData = ({
  idDivision,
  idTipoCobertura,
  fechaDesde,
  fechaHasta,
}) => {
  const [state, setState] = useState({
    isLoading: false,
    hasError: false,
    errorMessage: null,
    successMessage: null,
  });

  const [tramitesPorDelegacionAnualList, setTramitesPorDelegacionAnualList] = useState();
  const [tramitesPorDelegacionMensualList, setTramitesPorDelegacionMensualList] = useState();

  const currentMonthDateRange = {
    fechaDesde: dayjs().startOf('month').format('YYYY-MM-DD'),
    fechaHasta: dayjs().endOf('month').format('YYYY-MM-DD'),
  };

  const currentYearDateRange = {
    fechaDesde: dayjs().startOf('year').format('YYYY-MM-DD'),
    fechaHasta: dayjs().endOf('year').format('YYYY-MM-DD'),
  };

  /**
   * Recibe como parametro una función helper y controla su response
   * @param {function} callback
   * @returns response: Object
   */
  const apiCall = async (callback, data) => {
    setState({ ...state, isLoading: true });
    const response = await callback(data);

    setState({
      ...state,
      isLoading: false,
    });

    return response;
  };

  /**
   * Obtiene una lista de solicitudes de cobertura del año actual
   */
  const getTramitesPorDelegacionAnualList = async () => {
    const list = await apiCall(getSolicitudCoberturaTramitesPorDelegacion, {
      fechaDesde: currentYearDateRange.fechaDesde,
      fechaHasta: currentYearDateRange.fechaHasta,
      idDivision,
      idTipoCobertura,
    });

    setTramitesPorDelegacionAnualList(list);
  };

  /**
   * Obtiene una lista de solicitudes de cobertura del mes actual
   */
  const getTramitesPorDelegacionMensualList = async () => {
    const list = await apiCall(getSolicitudCoberturaTramitesPorDelegacion, {
      fechaDesde: currentMonthDateRange.fechaDesde,
      fechaHasta: currentMonthDateRange.fechaHasta,
      idDivision,
      idTipoCobertura,
    });

    setTramitesPorDelegacionMensualList(list);
    setState({ ...state, isLoading: false });
  };

  return {
    ...state,
    fechaAnioActual: currentYearDateRange.fechaDesde,
    fechaMesActual: currentMonthDateRange.fechaDesde,
    getTramitesPorDelegacionAnualList,
    getTramitesPorDelegacionMensualList,
    tramitesPorDelegacionAnualList,
    tramitesPorDelegacionMensualList,
  };
};
